// แผนที่ ModelType -> นามสกุลไฟล์ ใช้ร่วมกันหลาย view (upload vector / import user)
export function findTypeName(modelType) {
	let type = '';
	switch (modelType) {
		case 'CSV':
			type = '.csv';
			break;
		case 'Excel':
			type = '.xlsx';
			break;
		case 'ExcelMultiColumn':
			type = '.xlsx';
			break;
		case 'PDF':
			type = '.pdf';
			break;
		case 'Word':
			type = '.docx';
			break;
		case 'Text':
			type = '.txt';
			break;
		case 'PowerPoint':
			type = '.pptx';
			break;
	}
	return type;
}
